<div class="flex justify-center items-center py-10 border-t border-light-grey">
  <span class="text-mid-grey text-md">{{ text() }}</span>
</div>
